import { jsx } from 'react/jsx-runtime';
import { cn } from '../../lib/utils.js';

function Skeleton({ className, ...props }) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn("animate-pulse rounded-full bg-basic-background-04", className),
      ...props
    }
  );
}

export { Skeleton };
